import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import IntentDataModel from "../models/IntentDataModel";
import Utility from "../utilities/Utility";
import LocalIntentSubCon from "./submenu_contents/LocalIntentSubCon";
import { validateIntentInput, validateIntentName } from "../utilities";
import { IntentDetails, IntentDetailsMode } from "../page-components/modals";

export class IntentDropdown extends BaseComponent {
    get isIntentAuthorshipOn() {
        const { features = {} } = window.apm.serialized.rootSettings;
        return Boolean(features.intentManagement);
    }

    /**
     * Dropdown with a selection menu of app intents
     * @module IntentDropdown
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            label: this.props.label ? this.props.label : "",
            wide: this.props.hasOwnProperty("wide") ? " wide" : "",
            query: "",
            modalIsShowing: false,
            intentCandidate: {},
            isMenuOpen: false
        };

        this.state["selection"] = (this.props.hasOwnProperty("selection") && this.props.selection >= 0) ? this.props.options[this.props.selection] : this.initDataModel();
        this.state["selection"] = (this.props.context instanceof LocalIntentSubCon && this.props.selection !== -1) ? window.apm.knowledgeBase.getIntents()[this.props.selection] : this.state["selection"];
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
        this.eventHandler = this.handleEvent.bind(this);
        this.handleSelectIntent = this.handleSelectIntent.bind(this);
        this.openCreateIntentForm = this.openCreateIntentForm.bind(this);
        this.createAndUseIntent = this.createAndUseIntent.bind(this);
    }

    hasRemovable() {
        return this.props.hasOwnProperty("removable") && this.props.removable && this.state.selection && this.state.selection.value;
    }

    initDataModel() {
        return {name: this.getOptionName(), value: ""};
    }

    /**
     * Get the name for dropdown
     * @returns {string}
     */
    getOptionName() {
        return this.props.optionName ? this.props.optionName : this.getPropLabel("untitled");
    }

    /**
     * Get available options
     * @returns {Array}
     */
    getOptions() {
        return this.props.options ? this.props.options : [];
    }

    /**
     * Get reference to dropdown itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this)).children(".dropdown");
    }

    /**
     * Get reference to the error message container
     * @returns {jQuery}
     */
    getErrorContainer() {
        return $(ReactDOM.findDOMNode(this)).children(".form-error-tip");
    }

    /**
     * Show the selection menu
     */
    showMenu() {
        if (this.props.hasOwnProperty("diagramWidget") && this.props.diagramWidget) {
            window.apm.postEventToCurrentView({target: "request-hide-property-panel"});
        }
        this.getDomSelf().children(".dropdown-options").fadeIn(200).css("display", "table");
        this.getDomSelf().children(".dropdown-options").find("input:first").focus();
        this.setState({isMenuOpen: true});
    }

    /**
     * Hide the selection menu
     */
    hideMenu() {
        this.getDomSelf().children(".dropdown-options").fadeOut(200).css("display", "none");
        this.setState({isMenuOpen: false});
    }

    handleEvent(event) {
        if (this.hasRemovable() && event.type === "ev-property-dropdown-remove") {
            this.resetSelection();
        }
        if (event.type === "ev-property-refresh-error" && event.detail.target === this.props.valKey) {
            if (event.detail.error) {
                this.showErrorTip(event.detail.error);
            } else {
                this.hideErrorTip();
            }
        }
    }

    /**
     * Handle click on selection menu items
     * @param {Object} target React current event target
     */
    handleClick(target) {
        const listIdx = parseInt(target.dataset.id);
        this.setState({"selection": this.props.options[listIdx]});
        
        if (this.props.type === "view") {
            var canvasEv = new CustomEvent('ev-canvas-view-change', {detail: this.props.options[listIdx].value});
            document.dispatchEvent(canvasEv);
            window.apm.postEventToCurrentView({
                target: "request-change-view",
                event: {view: this.props.options[listIdx].value}
            });
        } else {
            this.updateContext(this.props.options[listIdx].value);
        }
        if (this.state.isMenuOpen) {
            this.hideMenu();
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutsideHandler);
        document.addEventListener('ev-property-dropdown-remove', this.eventHandler);
        document.addEventListener('ev-property-refresh-error', this.eventHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutsideHandler);
        document.removeEventListener('ev-property-dropdown-remove', this.eventHandler);
        document.removeEventListener('ev-property-refresh-error', this.eventHandler);
    }

    /**
     * Set the React reference of itself
     * @param {Object} node React node reference
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Hide itself if mouse click outside the boundary
     * @param {Object} event React event
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            if(!this.state.modalIsShowing) {
                this.hideMenu();
            } else {
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        }
    }

    handleSelectIntent(intentName) {
        const transformedName = intentName.toUpperCase().replace(/ /g, "_");
        if(!validateIntentName(transformedName)) {
            return;
        }
        const treeDom = $("#tl_container");
        const goodName = window.apm.getEligibleTreeName(treeDom, transformedName, "intent");
        const nodeModel = new IntentDataModel(goodName);
        const node = nodeModel.serialize();
        if(this.isIntentAuthorshipOn) {
            this.openCreateIntentForm(node);
        } else {
            this.createAndUseIntent(node);
        }
    }

    openCreateIntentForm(node) {
        this.setState({modalIsShowing: true, intentCandidate: node});
    }
    
    createAndUseIntent(intent) {
        if(this.isIntentAuthorshipOn) {
            this.setState({modalIsShowing: false});
        }
        if (this.state.isMenuOpen) {
            setTimeout(() => this.hideMenu(), 0);
        }
        if(!intent) {
            return;
        }
        const treeDom = $("#tl_container");
        window.apm.addNode(intent);
        treeDom.jstree().create_node("intents", Utility.getTreeNode(intent), "last");
        this.setState({
            "selection": {name: intent.name, value: intent.id},
            "query": ""
        });
        this.getDomSelf().find("input").val("");
        this.updateContext(intent.id);
        if (this.props.context.props.domContext && this.props.context.props.domContext.props.isTransitionCondition) {
            this.props.context.props.context.add(intent.id);
        }
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }

    validateWithHelpers(name) {
        const HelperText = (p) => (
            <div style={{textAlign: "center"}}>
                <label><em>{p.text}</em></label>
            </div>
        );

        return (validateIntentInput(name)) ? 
            <HelperText text="Press Enter to submit" />
            : 
            <HelperText text={this.getPropLabel("invalid_variable_name")} />;
    }

    resetSelection() {
        this.setState({"selection": this.initDataModel()});
        this.updateContext("");
        if (this.state.isMenuOpen) {
            this.hideMenu();
        }
    }

    /**
     * Show error message
     * @param {string} tip Error message
     * @param {string} type Message type
     */
    showErrorTip(tip, type = "error") {
        this.getErrorContainer().addClass(type).html(tip).show();
        this.getDomSelf().addClass(type).animateCss("shake");
        if (type === "warning") {
            // Auto hide warning after timeout
            if (this.timer !== null) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(this.hideErrorTip.bind(this), 3000);
        }
    }

    /**
     * Hide error message
     */
    hideErrorTip() {
        this.getDomSelf().removeClass("error").removeClass("warning");
        this.getErrorContainer().removeClass("error").removeClass("warning").html("&nbsp;").hide();
        this.timer = null;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <>
                {this.state.modalIsShowing && (
                    <IntentDetails
                        primaryLabel="Add Intent"
                        mode={IntentDetailsMode.edit}
                        intent={this.state.intentCandidate}
                        onComplete={this.createAndUseIntent}
                    />
                )}
                <div className={"form-component-container"}>
                    {this.state.label && (
                        [<label key={0} data-tip={this.props.tooltip}>{this.state.label}{(this.props.tooltip) ? <i className="fe icon-info"/> : ''}</label>, <br key={1}/>]
                    )}
                    <button className={"form-component dropdown"}
                            ref={this.setWrapperRef.bind(this)}
                            onKeyDown={event => {
                                switch (event.key) {
                                    case "Backspace":
                                    case "Delete":
                                    //DEVDES2-1613: Backspacing should only clear the dropdown when there is no more text to backspace
                                    if(this.state.query.length === 0) {
                                        event.preventDefault();
                                        this.resetSelection();
                                    }
                                }
                            }}
                            onClick={() => {
                                if (!this.props.readOnly) {
                                    this.showMenu();
                                }
                            }}
                    >
                        <div className="dropdown-selection">
                            <table>
                                <tbody>
                                <tr>
                                    <td className={this.state.selection.value ? "" : "no-selection"}>{this.state.selection.name}</td>
                                    {(() => {
                                        if (!this.hasRemovable() || this.props.readOnly) {
                                            return null;
                                        }
                                        return <td className={"dropdown-remove"}
                                                onClick={event => {
                                                    this.resetSelection();
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                }}>
                                            <i className={"fe icon-x"}/>
                                        </td>;
                                    })()}
                                    <td className="dropdown-icon"><i className="fe icon-chevron-down title-suffix-icon"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={"form-component dropdown-options"}>
                            <div className="title">
                                <table>
                                    <tbody>
                                    <tr>
                                        {(() => {
                                            if (this.props.hasOwnProperty("diagramWidget") && this.props.diagramWidget) {
                                                // Special case for toolbar dropdown; no search bar here
                                                return <td style={{paddingLeft: "8px"}}>{this.getOptionName()}</td>;
                                            }
                                            return <td><input
                                                type="text"
                                                placeholder={this.getOptionName()}
                                                className="form-component"
                                                onKeyDown={event => {
                                                    switch (event.key) {
                                                        case "Enter":
                                                            event.preventDefault();
                                                            this.handleSelectIntent(this.state.query);
                                                            break;
                                                        case "Tab":
                                                        case "ArrowDown":
                                                            event.preventDefault();
                                                            $(event.currentTarget).closest(".dropdown-options").find("li:first").focus();
                                                    }
                                                }}
                                                onInput={() => {
                                                    this.setState({query: this.getDomSelf().find("input").val()});
                                                }}
                                            /></td>;
                                        })()}
                                        <td className="dropdown-icon"><i
                                            className="fe icon-chevron-down title-suffix-icon"/></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            {this.state.selection.value && (
                                <div className="dropdown-current">{this.state.selection.name}</div>
                            )}
                            <div className="options">{(() => {
                                if (this.getOptions().length <= 0) {
                                    return this.validateWithHelpers(this.state.query);
                                } else {
                                    var list = [];
                                    const regex = new RegExp(this.state.query, "i");
                                    for (var i = 0; i < this.getOptions().length; i++) {
                                        var op = <li
                                            key={this.getOptionName() + "::" + i}
                                            data-id={i}
                                            tabIndex={0}
                                            onKeyDown={event => {
                                                event.preventDefault();
                                                switch (event.key) {
                                                    case "Tab":
                                                        this.hideMenu();
                                                        $(event.currentTarget).closest(".dropdown").focus();
                                                        break;
                                                    case "Enter":
                                                        this.handleClick(event.target);
                                                        break;
                                                    case "ArrowUp":
                                                        if ($(event.currentTarget).prev().length === 0) {
                                                            $(event.currentTarget).closest(".dropdown-options").find("input:first").focus();
                                                        }
                                                        $(event.currentTarget).prev().focus();
                                                        break;
                                                    case "ArrowDown":
                                                        $(event.currentTarget).next().focus();
                                                        break;
                                                }
                                            }}
                                            onClick={event => {
                                                this.handleClick(event.target);
                                                event.stopPropagation();
                                            }}
                                        >{this.getOptions()[i].name}</li>;
                                        if (this.state.query && !this.getOptions()[i].name.match(regex)) {
                                            continue;
                                        }
                                        list.push(op);
                                    }
                                    if (!list.length) {
                                        return this.validateWithHelpers(this.state.query);
                                    }
                                    return (<ul>{list}</ul>);
                                }
                            })()}</div>
                        </div>
                    </button>
                    <div className="form-error-tip">&nbsp;</div>
                </div>
            </>
        );
    }
}